import React from "react";
import { Spinner } from "react-bootstrap";
import { format } from "date-fns";
import { toast } from "react-toastify";

import OrderSummaryItems from "../../../Common/Components/OrderSummaryItems";
import TotalPriceCard from "../../../Common/Components/SummaryTotalPriceCard";
import OrderNotesPicker from "../../../Common/Components/OrderNotesPicker";

const SummaryStep = ({
  items,
  open,
  setOpen,
  deliveryType,
  code,
  setCode,
  checkCoupon,
  cLoading,
  coupon,
  address,
  setAddressModal,
  setShowWarning,
  loggedIn,
  sPickup,
  sPSlot,
  setShowPickup,
  sDelivery,
  sDSlot,
  setShowDelivery,
  pickupLoading,
  deliveryLoading,
  apiNotes,
  note,
  setNote,
}) => {
  return (
    <>
      {/* Items */}
      {items.length > 0 && (
        <OrderSummaryItems items={items} open={open} setOpen={setOpen} />
      )}
      {/* Pricing */}
      <div className="card mb-3">
        <div className="card-body py-2">
          <TotalPriceCard deliveryType={deliveryType} />
        </div>
      </div>

      {/* Coupon */}
      <div className="card mb-3">
        <div className="card-body">
          <span className="fw-semibold mb-3 d-block">Apply Coupon</span>
          <div className="input-group" style={{ height: "44px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Coupon Code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <button
              className={`btn fw-semibold ${coupon ? "btn-danger text-white" : "consumer-order-primary"}`}
              type="button"
              onClick={() => checkCoupon()}
              disabled={cLoading}
            >
              {cLoading ? (
                <Spinner size="sm" />
              ) : coupon ? (
                "Remove"
              ) : (
                "Apply"
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Address */}
      <div className="card mb-3">
        <div className="card-body">
          <span className="fw-semibold mb-3 d-block">Address</span>
          <div
            className="row cursor-pointer"
            onClick={() => {
              if (loggedIn) setAddressModal("pickup");
              else setShowWarning(true);
            }}
          >
            <div className="col-1 text-end pe-0">
              <i className="fa-solid fa-circle-dot" style={{ color: "#32b6e9" }}></i>
            </div>
            <div className="col-11">
              <h6 className="mb-1">Pickup Address</h6>
              <p className="m-0">
                {address.pickup
                  ? `${address.pickup?.address1}, ${address.pickup?.address2}, ${address.pickup?.area?.[0]?.name}, ${address.pickup?.phase?.[0]?.name}`
                  : "Select address"}
              </p>
              <hr style={{ borderStyle: "doted" }} />
            </div>
          </div>

          <div
            className="row cursor-pointer"
            onClick={() => {
              if (loggedIn) setAddressModal("delivery");
              else setShowWarning(true);
            }}
          >
            <div className="col-1 text-end pe-0">
              <i className="fa-solid fa-location-dot text-primary" style={{ fontSize: "20px" }}></i>
            </div>
            <div className="col-11">
              <h6 className="mb-1">Delivery Address</h6>
              <p className="m-0">
                {address.delivery
                  ? `${address.delivery?.address1}, ${address.delivery?.address2}, ${address.delivery?.area?.[0]?.name}, ${address.delivery?.phase?.[0]?.name}`
                  : "Select address"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Schedule Dates */}
      <div className="card mb-3">
        {!pickupLoading && !deliveryLoading ? (
          <div className="card-body">
            <span className="fw-semibold mb-3 d-block">Schedule Dates</span>
            <div className="app-dates-container border border-gray rounded mt-4 py-2 py-md-0">
              <div className="col-12 col-md-5 px-4">
                <small
                  style={{ position: "absolute", top: "-12px" }}
                  className="bg-white px-2"
                >
                  Pickup
                </small>
                <div
                  className="d-flex align-items-center py-3 border-r border-gray cursor-pointer"
                  onClick={() => setShowPickup(true)}
                >
                  <i
                    className="fa-regular fa-calendar-plus me-3"
                    style={{ fontSize: "22px", color: "#666" }}
                  ></i>
                  {sPickup ? format(sPickup, "eee, do MMM") : "Date"}
                  {sPSlot && sPickup ? <br /> : "/"}
                  {sPSlot
                    ? `${sPSlot?.start_time} - ${sPSlot?.end_time}`
                    : "Time"}
                </div>
              </div>
              <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
                &nbsp;
              </div>
              <hr className="w-100 my-2 d-block d-md-none" />
              <div className="col-12 col-md-5 px-4">
                <small
                  style={{ position: "absolute" }}
                  className={`bg-white px-2 app-dates-delivery-label ${
                    !sPickup && !sPSlot ? "alt" : ""
                  }`}
                >
                  Delivery
                </small>
                <div
                  className="d-flex align-items-center py-3 cursor-pointer"
                  onClick={() => {
                    if (sPickup && sPSlot) setShowDelivery(true);
                    else
                      toast.error(
                        "Please select pickup date & slot first..."
                      );
                  }}
                >
                  <i
                    className="fa-regular fa-calendar-plus me-3"
                    style={{ fontSize: "22px", color: "#666" }}
                  ></i>
                  {sDelivery ? format(sDelivery, "eee, do MMM") : "Date"}
                  {sDSlot && sDelivery ? <br /> : "/"}
                  {sDSlot
                    ? `${sDSlot?.start_time} - ${sDSlot?.end_time}`
                    : "Time"}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-100 text-center py-3">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>

      {/* Note */}
      <div className="card mb-3">
        <div className="card-body">
          <OrderNotesPicker
            apiNotes={apiNotes}
            value={note}
            onChange={setNote}
          />
        </div>
      </div>
    </>
  );
};

export default SummaryStep;
